<template>
  <transition name="call-slide">
    <div v-if="visible" class="incoming-call">
      <el-card shadow="always" class="call-card">
        <div class="call-body">
          <img src="@/assets/treatment/profile-img.png" class="avatar" alt="">
          <div class="info">
            <div class="title">视频通话请求</div>
            <div class="patient-name">{{ callData.patientInfo?.name || '未知患者' }}</div>
            <div class="caller">来自：{{ callData.callerInfo?.name || '第三方设备' }}</div>
            <div v-if="callData.diagRecordCode" class="record-code">诊疗号：{{ callData.diagRecordCode }}</div>
          </div>
        </div>
        <div class="call-actions">
          <el-button type="danger" size="small" icon="el-icon-close" @click="handleReject">拒绝</el-button>
          <el-button type="success" size="small" icon="el-icon-phone" @click="handleAccept">接听</el-button>
        </div>
      </el-card>
    </div>
  </transition>
</template>

<script>
import { acceptCall, rejectCall } from '@/utils/tuicallHelper'

export default {
  name: 'IncomingCall',
  data() {
    return {
      visible: false,
      callData: {
        roomId: '',
        diagRecordCode: '',
        callerUserId: '',
        callerInfo: {},
        patientInfo: {}
      }
    }
  },
  methods: {
    showCall(data) {
      this.callData = {
        ...data,
        callerUserId: data.callerUserId || data.sponsor || data.from || data.callerId
      }
      this.visible = true
    },
    hideCall() {
      this.visible = false
    },

    async handleReject() {
      this.visible = false
      try {
        await rejectCall()
      } catch (e) {
        console.warn('[TUICall] 拒绝失败（可能无活跃邀请）', e)
      }
    },

    async handleAccept() {
      try {
        await acceptCall()
      } catch (e) {
        console.warn('[TUICall] accept 失败（可能无活跃邀请），继续跳转', e)
      }

      this.visible = false
      const { roomId, diagRecordCode, callerUserId } = this.callData

      this.$router.push({
        path: '/business/treatment/medtreatment',
        query: {
          videoCall: true,
          roomId,
          diagRecordCode,
          callerUserId, // ✅ 对方 userId，用于订阅远端视频
          userData: diagRecordCode
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.incoming-call {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9999;
  width: 320px;

  .call-card {
    border-radius: 12px;
    background: #fff;
    border: 1px solid #e5e6eb;
  }

  .call-body {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      border: 2px solid #f0f2f5;
    }

    .info {
      .title {
        font-size: 14px;
        color: #909399;
        margin-bottom: 4px;
      }
      .patient-name {
        font-size: 18px;
        font-weight: 600;
        color: #1d2129;
      }
      .caller {
        font-size: 12px;
        color: #606266;
        margin-top: 4px;
      }
      .record-code {
        font-size: 12px;
        color: #165dff;
        margin-top: 4px;
        font-family: Roboto, sans-serif;
      }
    }
  }

  .call-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}

.call-slide-enter-active,
.call-slide-leave-active {
  transition: all 0.4s ease;
}
.call-slide-enter,
.call-slide-leave-to {
  transform: translateY(100px);
  opacity: 0;
}
</style>
